import { gql } from '~gql-types/gql'

export const FETCH_WARNING_CONFIGS = gql(`
  query WarningConfigs($ids: [ID!]!) {
    warningConfigs(ids: $ids) {
      id
      title
      message
      level
    }
  }
`)

export const UNLINK_BOARD = gql(`
  mutation UnlinkAllBoardLti($boardId: ID!) {
    unlinkAllBoardLti(boardId: $boardId) {
      id
      title
    }
  }
`)
